import React, { Component } from "react";
import BarChartAssignTo from "../BarChartAssignTo";
import BarChartDueDate from "../BarChartDueDate";
import BarChartStatus from "../BarChartStatus";
import PieChartAllocate from "../PieChartAllocate";
import config from "@config";
import errorFunctions from "@store/errorFunctions";
import apiEndpoints from "@store/apiEndpoints";
import moment from "moment";
import { IoIosRefreshCircle } from "react-icons/io";
import {
  AverageDaysSkeleton,
  NewTicketsSkeleton,
  OpenTicketAllocationSkeleton,
  OpenTicketDueDatesSkeleton,
  AllocatedOpenTicketSkeleton,
  TicketStatusSkeleton,
} from "@components/SkeletonLoading/DashboardSkeleton";

export default class Dashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      dashboardData: undefined,
      dataChart3: undefined,
      devices: undefined,
      lastUpdated: moment(),
      error: "",
      averageDaysToClose: 0,
      loadingAverageDays: false,
      errorAverageDays: null,
      newTicketData: { previous: 0, current: 0 },
      loadingNewTickets: false,
      errorNewTickets: null,
      openTicketAllocation: [],
      loadingOpenTicketAllocation: false,
      errorOpenTicketAllocation: null,
      allocatedOpenTicket: [],
      loadingAllocatedOpenTicket: false,
      errorAllocatedOpenTicket: null,
      openTicketDueDates: [],
      loadingOpenTicketDueDates: false,
      errorOpenTicketDueDates: null,
      ticketStatus: [],
      loadingTicketStatus: false,
      errorTicketStatus: null,
      brandIdSelected: "",
      allBrandIds: this.props.userInfo?.user?.brands
        ? this.props.userInfo?.user?.brands?.filter(
            (e) => e.country === config.country,
          )
        : [],
      isFetching: false,
    };
  }

  buildUrl = (url, useBrandId = true) => {
    const allBrandIds = this.state.allBrandIds
      .map((brand) => brand.id)
      .join(",");
    const roleSCA = this.props.userInfo?.user?.role === "Service Center Admin";
    const serviceCenter = this.props.userInfo?.user?.service_center?.find((s) =>
      s.name.includes("PTC"),
    );

    const hasQueryParams = url.includes("?");
    const serviceCenterParam =
      serviceCenter && roleSCA
        ? `${hasQueryParams ? "&" : "?"}service_center=${serviceCenter.id}`
        : "";

    const brandIdToUse =
      this.state.brandIdSelected === ""
        ? allBrandIds
        : this.state.brandIdSelected;

    const brandParam =
      useBrandId && brandIdToUse
        ? `${hasQueryParams || serviceCenterParam ? "&" : "?"}brand_id=${brandIdToUse}`
        : "";

    return url + serviceCenterParam + brandParam;
  };

  retrieveAverageDaysToClose = () => {
    this.setState({ loadingAverageDays: true, errorAverageDays: null });

    const url = this.buildUrl(apiEndpoints.dashboard.averageDaysToClose());

    this.props
      .protectedFetch(url, "GET", null, errorFunctions.checkResponseThenJson)
      .then((res) => {
        this.setState({
          averageDaysToClose: res.average_days_to_close || 0,
          loadingAverageDays: false,
          errorAverageDays: null,
        });
      })
      .catch((error) => {
        this.setState({
          loadingAverageDays: false,
          errorAverageDays: "Failed to load average days to close",
        });
        console.log("Failed to retrieve average days to close", error);
      });
  };

  retrieveNewTickets = () => {
    this.setState({ loadingNewTickets: true, errorNewTickets: null });

    const url = this.buildUrl(apiEndpoints.dashboard.newTicket());

    this.props
      .protectedFetch(url, "GET", null, errorFunctions.checkResponseThenJson)
      .then((res) => {
        this.setState({
          newTicketData: {
            previous: res.new_ticket_chart?.previous || 0,
            current: res?.new_ticket_chart?.current || 0,
          },
          loadingNewTickets: false,
          errorNewTickets: null,
        });
      })
      .catch((error) => {
        this.setState({
          loadingNewTickets: false,
          errorNewTickets: "Failed to load new tickets",
        });
        console.log("Failed to retrieve new tickets", error);
      });
  };

  retrieveOpenTicketAllocation = () => {
    this.setState({
      loadingOpenTicketAllocation: true,
      errorOpenTicketAllocation: null,
    });

    const url = this.buildUrl(apiEndpoints.dashboard.openTicketAllocation());

    this.props
      .protectedFetch(url, "GET", null, errorFunctions.checkResponseThenJson)
      .then((res) => {
        this.setState({
          openTicketAllocation: res || [],
          loadingOpenTicketAllocation: false,
          errorOpenTicketAllocation: null,
        });
      })
      .catch((error) => {
        this.setState({
          loadingOpenTicketAllocation: false,
          errorOpenTicketAllocation: "Failed to load open ticket allocation",
        });
        console.log("Failed to retrieve open ticket allocation", error);
      });
  };

  retrieveAllocatedOpenTicket = () => {
    this.setState({
      loadingAllocatedOpenTicket: true,
      errorAllocatedOpenTicket: null,
    });

    const url = this.buildUrl(apiEndpoints.dashboard.allocatedOpenTicket());

    this.props
      .protectedFetch(url, "GET", null, errorFunctions.checkResponseThenJson)
      .then((res) => {
        this.setState({
          allocatedOpenTicket: res.allocated_open_ticket_chart || [],
          loadingAllocatedOpenTicket: false,
          errorAllocatedOpenTicket: null,
        });
      })
      .catch((error) => {
        this.setState({
          loadingAllocatedOpenTicket: false,
          errorAllocatedOpenTicket: "Failed to load allocated open tickets",
        });
        console.log("Failed to retrieve allocated open ticket", error);
      });
  };

  retrieveOpenTicketDueDates = () => {
    this.setState({
      loadingOpenTicketDueDates: true,
      errorOpenTicketDueDates: null,
    });

    const url = this.buildUrl(apiEndpoints.dashboard.openTicketDueDates());

    this.props
      .protectedFetch(url, "GET", null, errorFunctions.checkResponseThenJson)
      .then((res) => {
        this.setState({
          openTicketDueDates: res?.open_ticket_due_dates_chart || [],
          loadingOpenTicketDueDates: false,
          errorOpenTicketDueDates: null,
        });
      })
      .catch((error) => {
        this.setState({
          loadingOpenTicketDueDates: false,
          errorOpenTicketDueDates: "Failed to load open ticket due dates",
        });
        console.log("Failed to retrieve open ticket due dates", error);
      });
  };

  retrieveTicketStatus = () => {
    this.setState({ loadingTicketStatus: true, errorTicketStatus: null });

    const url = this.buildUrl(apiEndpoints.dashboard.ticketStatus());

    this.props
      .protectedFetch(url, "GET", null, errorFunctions.checkResponseThenJson)
      .then((res) => {
        this.setState({
          ticketStatus: res?.ticket_status_chart || [],
          loadingTicketStatus: false,
          errorTicketStatus: null,
        });
      })
      .catch((error) => {
        this.setState({
          loadingTicketStatus: false,
          errorTicketStatus: "Failed to load ticket status",
        });
        console.log("Failed to retrieve ticket status", error);
      });
  };

  componentDidMount() {
    this.autoRefreshInterval = setInterval(
      () => this.initializeChartData(),
      3600000,
    );
    this.initializeChartData();
  }

  componentWillUnmount() {
    if (this.autoRefreshInterval) {
      clearInterval(this.autoRefreshInterval);
    }
  }

  componentDidUpdate(_, prevState) {
    if (prevState.brandIdSelected !== this.state.brandIdSelected) {
      if (this.state.isFetching) {
        return;
      }
      this.setState(
        {
          isFetching: true,
          lastUpdated: moment(),
          averageDaysToClose: 0,
          loadingAverageDays: true,
          newTicketData: { previous: 0, current: 0 },
          loadingNewTickets: true,
          openTicketAllocation: [],
          loadingOpenTicketAllocation: true,
          allocatedOpenTicket: [],
          loadingAllocatedOpenTicket: true,
          openTicketDueDates: [],
          loadingOpenTicketDueDates: true,
          ticketStatus: [],
          loadingTicketStatus: true,
        },
        () => {
          this.initializeChartData();

          setTimeout(() => {
            this.setState({ isFetching: false });
          }, 2000);
        },
      );
    }
  }

  initializeChartData = () => {
    this.setState({ lastUpdated: moment() });

    this.retrieveAverageDaysToClose();
    this.retrieveNewTickets();
    this.retrieveOpenTicketAllocation();
    this.retrieveAllocatedOpenTicket();
    this.retrieveOpenTicketDueDates();
    this.retrieveTicketStatus();
  };

  handleBrandChange = (event) => {
    const newValue = event.target.value;
    this.setState({ brandIdSelected: newValue });
  };

  getSelectedBrandId = () => {
    return this.state.brandIdSelected === ""
      ? this.state.allBrandIds?.map((brand) => brand.id).join(",")
      : this.state.brandIdSelected;
  };

  render() {
    return (
      <>
        <div>
          <div className="d-flex flex-row bd-highlight card mb-2 p-2">
            <div className="m-2">{`Last update: ${this.state.lastUpdated.format(
              "DD-MMM-YYYY HH:mm:ss ",
            )}`}</div>
            <button
              data-testid="refresh-btn"
              title="Refresh"
              className="btn btn-sm "
              onClick={() => this.initializeChartData()}
            >
              <IoIosRefreshCircle
                title="Reload data"
                style={{ fontSize: "1.5rem", color: "#0d6efd" }}
              />
            </button>

            <div className="d-flex flex-fill"></div>

            <div className="d-flex flex-row gap-2">
              <div className="m-2">{"Brand: "}</div>
              <div>
                <select
                  id="brandIdSelected"
                  className="form-select"
                  onChange={this.handleBrandChange}
                  value={this.state.brandIdSelected}
                >
                  <option value="">All Brands</option>
                  {this.props.userInfo?.user?.brands
                    ? this.props.userInfo?.user?.brands
                        ?.filter((e) => e.country === config.country)
                        .map((brand) => (
                          <option key={brand.id} value={brand.id}>
                            {brand.name}
                          </option>
                        ))
                    : null}
                </select>
              </div>
            </div>
          </div>

          <div className="row mb-4">
            <div className="col-md-6">
              <div
                className="card mb-2"
                style={{ textAlign: "center", height: "20vh" }}
              >
                {this.state.loadingAverageDays ? (
                  <AverageDaysSkeleton />
                ) : (
                  <>
                    <div className="card-header">
                      AVERAGE DAYS TO CLOSE TICKETS
                    </div>
                    <div className="card-body">
                      {this.state.errorAverageDays ? (
                        <div className="alert alert-danger mt-4" role="alert">
                          {this.state.errorAverageDays}
                        </div>
                      ) : (
                        <h2 className="mt-4">
                          {this.state.averageDaysToClose || 0}
                        </h2>
                      )}
                    </div>
                  </>
                )}
              </div>
              <div
                className="card"
                style={{ textAlign: "center", height: "20vh" }}
              >
                {this.state.loadingNewTickets ? (
                  <NewTicketsSkeleton />
                ) : (
                  <>
                    <div className="card-header">NEW TICKETS</div>
                    {this.state.errorNewTickets ? (
                      <div className="card-body d-flex align-items-center justify-content-center">
                        <div className="alert alert-danger" role="alert">
                          {this.state.errorNewTickets}
                        </div>
                      </div>
                    ) : (
                      <div className="row" style={{ height: "20vh" }}>
                        <div className="col-md-6 border-right">
                          <div className="card-body">
                            <div className="mt-4">Previous</div>
                            <div>
                              <h2>
                                <a
                                  style={{
                                    color: "black",
                                    textDecoration: "none",
                                  }}
                                  href="/tickets?newtickets=previous"
                                >
                                  {this.state.newTicketData.previous || 0}
                                </a>
                              </h2>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6 ">
                          <div className="card-body">
                            <div className="mt-4">Today</div>
                            <div>
                              <h2>
                                <a
                                  style={{
                                    color: "black",
                                    textDecoration: "none",
                                  }}
                                  href="/tickets?newtickets=today"
                                >
                                  {this.state.newTicketData.current || 0}
                                </a>
                              </h2>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
            <div className="col-md-6">
              <div className="card d-flex align-items-center justify-content-center h-100">
                {this.state.loadingOpenTicketAllocation ? (
                  <OpenTicketAllocationSkeleton />
                ) : (
                  <>
                    <h6 className="mt-1">Open Tickets Allocation</h6>
                    {this.state.errorOpenTicketAllocation ? (
                      <div className="alert alert-danger m-3" role="alert">
                        {this.state.errorOpenTicketAllocation}
                      </div>
                    ) : (
                      <div style={{ width: "50%" }}>
                        {this.state.openTicketAllocation && (
                          <PieChartAllocate
                            type="pie"
                            selectedBrandID={this.props.selectedBrandID}
                            data={this.state.openTicketAllocation}
                            className="mt-2"
                            brandId={this.getSelectedBrandId()}
                          />
                        )}
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
          <div className="row mb-4">
            <div className="col-md-6">
              <div className="card d-flex align-items-center justify-content-center">
                {this.state.loadingOpenTicketDueDates ? (
                  <OpenTicketDueDatesSkeleton />
                ) : (
                  <>
                    <h6 className="mt-2">Open Tickets Due Dates</h6>
                    {this.state.errorOpenTicketDueDates ? (
                      <div className="alert alert-danger m-3" role="alert">
                        {this.state.errorOpenTicketDueDates}
                      </div>
                    ) : (
                      <div style={{ width: "90%", marginBottom: "20px" }}>
                        <BarChartDueDate
                          type="bar"
                          data={this.state.openTicketDueDates}
                          brandId={this.getSelectedBrandId()}
                        />
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
            <div className="col-md-6">
              <div className="card d-flex align-items-center justify-content-center">
                {this.state.loadingAllocatedOpenTicket ? (
                  <AllocatedOpenTicketSkeleton />
                ) : (
                  <>
                    <h6 className="mt-2">Allocated Open Tickets</h6>
                    {this.state.errorAllocatedOpenTicket ? (
                      <div className="alert alert-danger m-3" role="alert">
                        {this.state.errorAllocatedOpenTicket}
                      </div>
                    ) : (
                      <div style={{ width: "90%", marginBottom: "20px" }}>
                        <BarChartAssignTo
                          type="bar"
                          data={this.state.allocatedOpenTicket}
                          brandId={this.getSelectedBrandId()}
                        />
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
          <div className="row ">
            <div className="col-md-12">
              <div className="card d-flex align-items-center justify-content-center mb-4">
                {this.state.loadingTicketStatus ? (
                  <TicketStatusSkeleton />
                ) : (
                  <>
                    <h6 className="mt-2">Ticket Status</h6>
                    {this.state.errorTicketStatus ? (
                      <div className="alert alert-danger m-3" role="alert">
                        {this.state.errorTicketStatus}
                      </div>
                    ) : (
                      <div style={{ width: "60%" }}>
                        <BarChartStatus
                          data={this.state.ticketStatus}
                          brandId={this.getSelectedBrandId()}
                        />
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
